<span
  class="ktbl-sub-table-header-base ktbl-sub-table-header-background-einzel ktbl-typografie-reg-14-zwischenueberschrift">
  {{ modulPrAuspFilter.modul }}
</span>

<table mat-table [dataSource]="dataSource" class="ktbl-table-breite-komplett">

  <ng-container *ngFor="let column of displayedColss; let j = index" [matColumnDef]="column">

    <td mat-cell *matCellDef="let entry; let i = index" [ngClass]="{
        'ktbl-table-content-normal': i % 2 === 0,
        'ktbl-table-content-invert': i % 2 !== 0,
        'ktbl-table-content-border': j === 0,
        'ktbl-table-cell-center': column === 'COMBOBOX',
        'ktbl-table-cell-no-padding-left': column === 'COMBOBOX',
        'ktbl-select-width': column === 'COMBOBOX',
        'ktbl-links-ausgerichtet-padding': column === 'WERT'
      }">

      <ng-container *ngIf="column === 'COMBOBOX'">
        <mat-checkbox class="example-margin" (change)="setCheckbox(entry.idMbMMa)">
        </mat-checkbox>
      </ng-container>

      <ng-container *ngIf="column === 'WERT'">
        {{ entry.auspraegung }} ({{ entry.anzahl }})
      </ng-container>

    </td>

  </ng-container>

  <tr mat-row *matRowDef="let row; columns: displayedColss"></tr>

</table>